import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Hub, MarketplaceApp} from 'yougile-model'
import {Input} from '@components/common/base/input'
import {useForceUpdate} from '@containers/hooks'
import {cn} from '@containers/html-utils'
import {useScriptsApiNavStore} from '../scripts-api-nav-store'
import {useScriptsCodeStore} from './../scripts-code-store'
import {useScriptsStore} from './../scripts-store'
import {CodeFileItem} from './code-file-item'

export const CodeFiles = observer(() => {
  const [, store] = useScriptsStore()
  const [codeState, codeStore] = useScriptsCodeStore()
  const [, apiNavStore] = useScriptsApiNavStore()
  const forceUpdate = useForceUpdate()

  return (
    <div className="scr-code-files">
      <div className="scr-code-actions">
        {!codeState.openedTab && (
          <>
            <i
              className="fa fa-plus"
              title={Lang.msg.addScriptHint}
              onClick={() => codeStore.setNew(true)}
            />
            <i
              className="fa fa-upload"
              title={Lang.msg.uploadScriptHint}
              onClick={() => codeStore.uploadScript()}
            />
            <i
              className="fa fa-check-circle"
              title={Lang.msg.reloadScriptsForAllUsers}
              onClick={() => codeStore.reloadScripts()}
            />
          </>
        )}

        {(codeState.openedTab as Hub)?.dataType === 'Hub' && (
          <>
            <i
              className="fa fa-play"
              title={Lang.msg.runScriptHint}
              onClick={() => codeStore.runScript()}
            />
            <i
              className={`fa fa-save ${
                !codeState.changed[codeState.openedTab.id] ? 'disabled' : ''
              }`}
              title={Lang.msg.saveScriptHint}
              onClick={() => codeStore.saveScript()}
            />
            {codeStore.isEnabled(codeState.openedTab) ? (
              <div
                className="scr-file-activate"
                onClick={() => {
                  codeStore.toggleEnabled(codeState.openedTab)
                  forceUpdate()
                }}
                title={Lang.msg.enabledScriptHint}
              >
                <i className="fa fa-toggle-on" /> {Lang.msg.enabledScript}
              </div>
            ) : (
              <div
                className="scr-file-activate"
                onClick={() => {
                  codeStore.toggleEnabled(codeState.openedTab)
                  forceUpdate()
                }}
                title={Lang.msg.disabledScriptHint}
              >
                <i className="fa fa-toggle-off" /> {Lang.msg.disabledScript}
              </div>
            )}
          </>
        )}
        {!!codeState.openedTab &&
          (codeState.openedTab as Hub).dataType !== 'Hub' && (
            <div
              className="_link scr-app-copy"
              onClick={() =>
                codeStore.copyApp(codeState.openedTab as MarketplaceApp)
              }
            >
              <i className="fa fa-copy" />
              {Lang.msg.apiAppCopy}
            </div>
          )}
      </div>

      <div className="scr-code-cnt">
        {!codeState.openedTab && (
          <div className="scr-code-file-cnt">
            <div className="scr-code-sub-head">{Lang.msg.yourScripts}:</div>
            {!!codeState.addNew && (
              <div className="scr-code-add">
                <Input
                  placeholder={Lang.msg.scriptNamePlaceholder}
                  onSubmit={codeStore.submit}
                  onCancel={codeStore.cancel}
                  onBlur={codeStore.submit}
                  autoFocus
                  size="24"
                  borders={false}
                />
              </div>
            )}

            {!codeState.addNew && !codeState.listScripts.length ? (
              <div className="scr-code-no-files">
                {Lang.msg.noScripts1}
                <span className="_link" onClick={() => codeStore.setNew(true)}>
                  {Lang.msg.noScripts2}
                </span>
                .
              </div>
            ) : (
              codeState.listScripts.map(script => (
                <CodeFileItem key={script.id} script={script} />
              ))
            )}

            <div className="scr-code-sub-head scr-code-presets-head">
              {Lang.msg.scriptPresets}:
            </div>
            {codeStore.listApps().map(app => (
              <div key={app.id} className="scr-code-file-item">
                <i className="fa fa-file-code-o scr-file-icon" />
                <span
                  className="scr-file-name"
                  title="Open this script"
                  onClick={() => codeStore.openTab(app)}
                >
                  {codeStore.getName(app)}
                </span>
                <span className="scr-file-hint">{codeStore.getHint(app)}</span>
                <div className="scr-file-actions">
                  <div
                    className="_link scr-app-copy"
                    onClick={() => codeStore.copyApp(app)}
                  >
                    <i className="fa fa-copy" />
                    {Lang.msg.apiAppCopy}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div
          className={cn('scr-editor-cnt', !codeState.openedTab && 'invisible')}
          onDragOver={apiNavStore.onDragOver}
          onDragLeave={apiNavStore.onDragLeave}
          onDrop={apiNavStore.onDrop}
        >
          <div className="loading transparent" />
          <div
            className="scr-editor"
            style={{height: '100%', width: '100%'}}
            ref={store.initEditor}
          />
        </div>
      </div>
    </div>
  )
})
